/*
 * File: /src/store/modules/knowledgeTypes.js
 * Author: AdBase, Inc.
 * Copyright (c) 2026 AdBase, Inc.
 */

import KnowledgeTypeService from 'src/services/knowledgeTypeService';

const state = {
  knowledgeTypes: undefined
};

const getters = {
  getKnowledgeTypes: state => state.knowledgeTypes
};

const actions = {
  async fetchKnowledgeTypes({ commit, state }) {
    // Only load the data once
    if (state.knowledgeTypes == undefined) {
      return KnowledgeTypeService.fetchKnowledgeTypes({
        limit: 1000,
        sort: 'name:asc',
      })
        .then(r => {
          commit('setKnowledgeTypes', Array.isArray(r.data) ? r.data : []);
        });
    }
  },
  // Keep the loaded list current after a create or an edit rather than
  // making every view reload the whole set
  upsertKnowledgeType({ commit }, knowledgeType) {
    if (knowledgeType && knowledgeType.id) {
      commit('upsertKnowledgeType', knowledgeType);
    }
  },
  removeKnowledgeType({ commit }, id) {
    commit('removeKnowledgeType', id);
  },
  unloadKnowledgeTypes({ commit }) {
    commit('setKnowledgeTypes', undefined);
  },
};

const byName = (first, second) =>
  String(first.name || '').localeCompare(String(second.name || ''));

const mutations = {
  setKnowledgeTypes(state, knowledgeTypes) {
    state.knowledgeTypes = knowledgeTypes;
  },
  upsertKnowledgeType(state, knowledgeType) {
    // Nothing is loaded yet, the next fetch will pick this one up
    if (state.knowledgeTypes == undefined) {
      return;
    }
    const types = state.knowledgeTypes.filter(
      type => type.id != knowledgeType.id
    );
    types.push(knowledgeType);
    state.knowledgeTypes = types.sort(byName);
  },
  removeKnowledgeType(state, id) {
    if (state.knowledgeTypes == undefined) {
      return;
    }
    state.knowledgeTypes = state.knowledgeTypes.filter(type => type.id != id);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
